// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1GIXI","module":"styles_module__3oDJm","margin":"styles_margin__25maN"};